<ion-header>
    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-back-button defaultHref="admin"></ion-back-button>
      </ion-buttons>
      <ion-title>Coaches</ion-title>
    </ion-toolbar>
  </ion-header>
  
  <ion-content class="ion-padding">

    <app-list-search
      [userList]="coaches"
      [isGroupSearch]="true"
      (searchResult)="searchedTeams"
    ></app-list-search>

    @if(coaches?.length){
        <ion-list class="content-width">
            <ion-item-group *ngFor="let pg of coaches">
              <ion-item-divider>
                <ion-label>{{ pg.initial }}</ion-label>
              </ion-item-divider>
        
              <ion-item *ngFor="let user of pg.players" [routerLink]="[user._id]">
                <ion-avatar slot="start">
                  <img
                    *ngIf="user?.profile_image; else defaultAvatar"
                    [src]="user.profile_image"
                    alt="Profile Image"
                  />
                </ion-avatar>
                <ng-template #defaultAvatar>
                  <!-- <ion-avatar> -->
                  <!-- <ion-icon name="person-circle-outline" size="large"></ion-icon> -->
                  <img class="avatarImage" [src]="avatarImage" />
                  <!-- </ion-avatar> -->
                </ng-template>
                <ion-label> {{ user.first_name }} {{ user.last_name }} </ion-label>
              </ion-item>
            </ion-item-group>
        </ion-list>
      } @else {
        <ng-template #noCoaches>
            <ion-text color="medium">
              <p class="ion-text-center">No coaches found.</p>
            </ion-text>
          </ng-template>
      }
  
    

    <ion-fab vertical="bottom" horizontal="end" slot="fixed">
        <ion-fab-button (click)="createCoach()">
            <ion-icon name="add"></ion-icon>
        </ion-fab-button>
    </ion-fab>
  
  </ion-content>
  